import Alert from '@material-ui/lab/Alert';

export default function ErrorFallback({error, componentStack}) {
  // TODO: Send error to developer: { error, componentStack }
  return <Alert severity="error">Woops! something went wrong.</Alert>
}
